export const departmentFormDefaults = {
  name: "",
  user: null,
  hashtag: "",
  imageUrl: null,
  blurredImage: true,
  area: { path: "/", name: "" },
};
